import CancelButton from 'components/buttons/CancelButton';
import PrimaryButton from 'components/buttons/PrimaryButton';
import ModalFooterContainer from 'components/containers/ModalFooterContainer';

import useTranslation from './hooks/useTranslation';

import { CANCEL_BUTTON_TEST_ID, SAVE_BUTTON_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ServiceIntervalsModalFooter: FunctionComponent<Props> = ({
    className = '',
    isSaveDisabled = false,
    onCancel,
    onSave,
    testId = TEST_ID
}) => {
    const { SAVE } = useTranslation();

    return (
        <ModalFooterContainer
            className={`${className} ${styles.serviceIntervalsModalFooter}`}
            testId={testId}>
            <CancelButton
                className={styles.button}
                onClick={onCancel}
                testId={CANCEL_BUTTON_TEST_ID}
            />

            <PrimaryButton
                className={styles.button}
                isDisabled={isSaveDisabled}
                onClick={onSave}
                testId={SAVE_BUTTON_TEST_ID}
                text={SAVE}
            />
        </ModalFooterContainer>
    );
};

export default ServiceIntervalsModalFooter;
